















import Vue from "vue";
export default Vue.extend({
  name: "DistanceCalulator",

  props: {
    marker1: {
      type: [Object, null],
      required: false
    },
    marker2: {
      type: [Object, null],
      required: false
    },
    measurementMode: {
      type: Boolean,
      required: true,
      default: false
    }
  },

  computed: {
    distance(): string {
      if (!this.marker1 || !this.marker2) return;
      const R = 6371.071; // Radius of the Earth in km
      const rlat1 = this.marker1.position.lat() * (Math.PI / 180); // Convert degrees to radians
      const rlat2 = this.marker2.position.lat() * (Math.PI / 180); // Convert degrees to radians
      const difflat = rlat2 - rlat1; // Radian difference (latitudes)
      const difflon =
        (this.marker2.position.lng() - this.marker1.position.lng()) *
        (Math.PI / 180); // Radian difference (longitudes)
      const d =
        2 *
        R *
        Math.asin(
          Math.sqrt(
            Math.sin(difflat / 2) * Math.sin(difflat / 2) +
              Math.cos(rlat1) *
                Math.cos(rlat2) *
                Math.sin(difflon / 2) *
                Math.sin(difflon / 2)
          )
        ) *
        1000;

      if (d < 1000) {
        return `${Math.floor(d)} m`;
      }

      return `${(d / 1000).toFixed(2)} km`;
    }
  }
});
